import moment from 'moment';
export default {
	//유형 selectBox
	getPartClCdList_({ partClCdList }) {
		const list = [];
		// list.push({ label: 'Select', value: '' });
		partClCdList.length && partClCdList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//종합판정 selectBox
	getOvrlJgmtCdList_({ ovrlJgmtCdList }) {
		const list = [];
		// list.push({ label: 'Select', value: '' });
		ovrlJgmtCdList.length && ovrlJgmtCdList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//검사분류 selectBox
	getCkuClCdList_({ ckuClCdList }) {
		const list = [];
		// list.push({ label: 'Select', value: '' });
		ckuClCdList.length && ckuClCdList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//검사구분 selectBox
	getCkuScnCdList_({ ckuScnCdList }) {
		const list = [];
		// list.push({ label: 'Select', value: '' });
		ckuScnCdList.length && ckuScnCdList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//대분류(검사항목) selectBox
	getCkuPrvsCdList_({ ckuPrvsCdList }) {
		const list = [];
		// list.push({ label: 'Select', value: '' });
		ckuPrvsCdList.length && ckuPrvsCdList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//검사방법 selectBox
	getCkuWayCdList_({ ckuWayCdList }) {
		const list = [];
		// list.push({ label: 'Select', value: '' });
		ckuWayCdList.length && ckuWayCdList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//합불기준 selectBox
	getPassDsqfCdList_({ passDsqfCdList }) {
		const list = [];
		// list.push({ label: 'Select', value: '' });
		passDsqfCdList.length && passDsqfCdList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//합불기준 selectBox
	getIndvJgmtCdList_({ indvJgmtCdList }) {
		const list = [];
		// list.push({ label: 'Select', value: '' });
		indvJgmtCdList.length && indvJgmtCdList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	//검사상태 selectBox
	getPgsStPcCdList_({ pgsStPcCdList }) {
		const list = [];
		// list.push({ label: 'Select', value: '' });
		pgsStPcCdList.length && pgsStPcCdList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	},
	getSearchMonths_({ searchParams: { strDt, endDt } }) {
		return [moment(strDt).year('YYYYMMDD'), moment(endDt).year('YYYYMMDD')];
	},
	totalSize_: state => {
		const { totalSize } = state.pagingInfo;
		return totalSize;
	},

	pageUnit_: state => {
		const { pageUnit } = state.pagingInfo;
		return pageUnit;
	}
};
